import React from 'react';
import { useLangTranslation } from '../utils/translation';
import './TPBDownloads.css';

// Keep all three placements in sync. Internal-sharing URLs expire after 60 days.
// iOS opens the TestFlight App Store listing for existing invited testers.
export const TPB_DOWNLOAD_LINKS = {
  android: 'https://play.google.com/apps/internaltest/4701204828887843325',
  ios: 'https://apps.apple.com/kr/app/testflight/id899247664',
};

export default function TPBDownloads() {
  const t = useLangTranslation('games');
  return <div className="tpb-downloads" role="group" aria-label={t('downloads.title')}>
    <span className="tpb-download-label">{t('downloads.title')}</span>
    <div className="tpb-download-badges">
      <a className="tpb-store-badge tpb-app-store-badge" href={TPB_DOWNLOAD_LINKS.ios} target="_blank" rel="noopener noreferrer" aria-label={t('downloads.iosLabel')}>
        <img src="/assets/badges/app-store-black.png" alt="Download on the App Store" width="718" height="240" />
      </a>
      <a className="tpb-store-badge tpb-google-play-badge" href={TPB_DOWNLOAD_LINKS.android} target="_blank" rel="noopener noreferrer" aria-label={t('downloads.androidLabel')}>
        <img src="/assets/badges/google-play-official.png" alt="Get it on Google Play" width="564" height="168" />
      </a>
    </div>
  </div>;
}
